<script>
import appConfig from "@/app.config";

export default {
  data() {
    return {
      version: appConfig.version,
    }
  }
}
</script>

<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ new Date().getFullYear() }} © Movix</div>
        <div class="col-sm-6">
          <div class="text-sm-right d-none d-sm-block">v{{version}} - Desenvolvido por <a href="https://mobwit.com.br" target="_blank">Mobwit</a></div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
